import { Banner } from '@customerio/pluma-components/react';
import type { PromoCode } from '@/services/signup/api';
import { promoBannerDescription } from '../utils/promo-banner-description';

type SignupPromoBannerProps = {
  promo: PromoCode;
};

/**
 * Coupon banner shown above the entry-step panel when the visitor arrived with
 * a valid promo code in the URL. Mirrors the checkout page's coupon banner.
 */
export function SignupPromoBanner({ promo }: SignupPromoBannerProps) {
  return (
    <Banner
      variant="success"
      title="Discount valid!"
      description={promoBannerDescription(promo)}
      mb="300"
      data-test-signup-promo-banner
    />
  );
}
